import GetAppIcon from '@material-ui/icons/GetApp'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import _ from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { CSVLink } from 'react-csv'
import {
  AiFillCheckSquare,
  AiFillClockCircle,
  AiFillCloseSquare
} from 'react-icons/ai'
import { useDispatch } from 'react-redux'
import Select from 'react-select'
import { getRequest, postRequest } from '../../../globalhelper/helper'
import Pattern_Popup from './PatternScreen'
// import Pattern_Popup from './NewPattern'
import CloseIcon from '@mui/icons-material/Close'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Tab from '@mui/material/Tab'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormLabel,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TableFooter,
  TablePagination,
  useTheme,
  Pagination,
  Alert,
  AlertTitle
} from '@mui/material'
import PropTypes from 'prop-types'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import { Rowing } from '@material-ui/icons'
import { fetchData } from '../../../redux/Tree/treeActions'

const Ledger_Type = [
  // "Instructor", "Batch",
  // 'CreditCard',
  // 'DigitalWalletAccounting',
  // 'EmployeeReimbursement',
  // 'EmployeeCost',
  // 'EmployeeCostAccrued',
  // 'EmployeeCostFnF',
  // 'EmployeeCostAccruedReversal',
  // 'GL',
  // 'InstructorCostAccrual',
  // 'InstructorAccrualReversal',
  // 'InstructorInvoice',
  'Journal',
  // 'PettyCash',
  'Payment',
  'VendorAdvancePayment',
  'Vendor'
]
// const View_Type = [ "Ledger", "CostVsRev", "Accruals", "Account Ledger", "Tax Liability" ]
const Ac_Type = ['ProvAc', 'ExpAc', 'CreditorsAc', 'PrePaidAc']

const PATTERN_GROUP = {
  CreditCard: 'HDFC-CC1',
  PettyCash: 'Edureka_PC',
  EmployeeReimbursement: 'Edureka_ER',
  DigitalWalletAccounting: 'VOLO-DWA1'
}

const ALLOW_FOR_PATTERN = [
  'CreditCard',
  'PettyCash',
  'EmployeeReimbursement',
  'DigitalWalletAccounting'
]

export default function LedgerView () {
  const [readMoreItem, setReadMoreItem] = useState([])
  const [openDialogue, setOpenDialogue] = useState(false)
  const [popupView, setPopupview] = useState('pattern')
  const [Companies, setCompanies] = useState([])
  const [Company, setCompany] = useState('')
  const [LedgerType, setLedgerType] = useState('')
  const [AllKeyRef, setAllKeyRef] = useState([])
  const [KeyRef, setKeyRef] = useState('')
  const [From, setFrom] = useState('')
  const [To, setTo] = useState('')
  const [totalDebit, set_totalDebit] = useState('')
  const [totalCredit, set_totalCredit] = useState('')

  const [selectedRow, setSelectedRow] = useState(null)
  const tableRef = useRef(null)
  const buttonRef = useRef(null)
  const [message, setMessgae] = useState(null)
  const [fetchedData, set_fetchedData] = useState([])
  const [displayData, set_displayData] = useState([])

  const [AcGroupList, set_AcGroupList] = useState([])
  const [AcClassList, set_AcClassList] = useState([])
  const [AcCodeList, set_AcCodeList] = useState([])
  const [KeyRefList, set_KeyRefList] = useState([])

  const [All_AcGroupList, set_All_AcGroupList] = useState([])
  const [All_AcClassList, set_All_AcClassList] = useState([])
  const [All_AcCodeList, set_All_AcCodeList] = useState([])
  const [All_KeyRefList, set_All_KeyRefList] = useState([])

  const [SelAcGroupList, set_SelAcGroupList] = useState([])
  const [SelAcClassList, set_SelAcClassList] = useState([])
  const [SelAcCodeList, set_SelAcCodeList] = useState([])
  const [SelKeyRefList, set_SelKeyRefList] = useState([])

  const [PATTERN__JSONS, set_PATTERN__JSONS] = useState({})
  const [PATTERN_JSON, set_PATTERN_JSON] = useState(null)
  const [popupVisible, setPopupVisible] = useState(false)

  const [ItemMaster, set_ItemMaster] = useState([])
  const [VendorMaster, set_VendorMaster] = useState([])
  const [BankRef, set_BankRef] = useState([])

  let [CreditorsAc, setCreditorsAc] = useState({})

  let [BillsByOrgID, setBillsByOrgID] = useState({})
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  let dispatch = useDispatch()
  useEffect(() => {
    getRequest(`api/veranda/getCompany0`).then(res => {
      if (res.type === 'success') {
        let data = JSON.parse(res.res.data)

        data = _.sortBy(data, 'orgname')

        setCompanies(data)
        if (data.length === 1) {
          updateCompany({
            value: data[0].orgid,
            label: `${data[0].orgname}(${data[0].orgid})`
          })
        }
      }
    })

    var currentDate = new Date()

    var firstDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    )

    var lastDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    )

    function formatDate (date) {
      var year = date.getFullYear()
      var month = (date.getMonth() + 1).toString().padStart(2, '0')
      var day = date.getDate().toString().padStart(2, '0')
      return year + '-' + month + '-' + day
    }

    var formattedFirstDay = formatDate(firstDay)
    var formattedLastDay = formatDate(lastDay)

    setFrom(formattedFirstDay)
    setTo(formattedLastDay)
  }, [])

  const fetchBills = async OrgID => {
    setBillsByOrgID(prevState => ({
      ...prevState,
      isLoading: true,
      Bills: [],
      Error: ''
    }))

    try {
      const response = await getRequest(
        `api/veranda/getBillsByOrgID?OrgID=${OrgID}`
      )
      if (response?.res?.data) {
        const bills = JSON.parse(response.res.data)
        setBillsByOrgID(prevState => ({
          ...prevState,
          Bills: bills
        }))
      } else {
        throw new Error('Invalid response data')
      }
    } catch (err) {
      console.error('Error fetching bills:', err)
      setBillsByOrgID(prevState => ({
        ...prevState,
        Error: 'Failed to fetch bills data.'
      }))
    } finally {
      setBillsByOrgID(prevState => ({
        ...prevState,
        isLoading: false
      }))
    }
  }

  const handleReadMore = index => {
    if (readMoreItem.includes(index)) {
      let updated = readMoreItem.filter(ind => ind !== index)
      setReadMoreItem(updated)
    } else {
      setReadMoreItem(prev => [...prev, index])
    }
  }

  const updateCompany = async val => {
    setCompany(val.label)
    getRequest(`api/veranda/getALLvendor_master?OrgID=${val.value}`).then(
      res => {
        if (res.res.status === 'success') {
          let data = res.res.data

          set_VendorMaster(data)
        }
      }
    )
    getRequest(`api/veranda/getALLitem_master?OrgID=${val.value}`).then(res => {
      if (res.res.status === 'success') {
        let data = res.res.data

        set_ItemMaster(data)
      }
    })
    getRequest(`api/veranda/getALLBankRef?OrgID=${val.value}`).then(res => {
      if (res.res.status === 'success') {
        let data = res.res.data

        set_BankRef(data)
      }
    })
  }

  // useEffect(() => {
  //   if (From && To && Company && LedgerType) {
  //     getRequest(
  //       `api/veranda/getKeyRef?From=${From}&To=${To}&LedgerType=${LedgerType}&OrgID=${Company}`
  //     ).then(res => {
  //       if (res.type === 'success') {
  //         const data = JSON.parse(res.res.data)

  //         setAllKeyRef(data.map(each => each['Key Ref']))
  //       }
  //     })
  //   }
  // }, [From, To, Company, LedgerType])

  const updateLedger = val => {
    setLedgerType(val)
  }

  const updateKeyRef = val => {
    setKeyRef(val)
  }

  const updateFrom = val => {
    setFrom(moment(val).format('YYYY-MM-DD'))
  }

  const updateTo = val => {
    setTo(moment(val).format('YYYY-MM-DD'))
  }

  const onFetch = e => {
    buttonRef.current.blur()

    let obj = {
      LedgerType: LedgerType,
      OrgID: Company,
      KeyRef: KeyRef.value,
      From: From,
      To: To
    }

    postRequest('api/veranda/fetchDataForLedger', { data: obj }).then(res => {
      set_displayData([])
      set_fetchedData([])
      set_totalDebit([])
      set_totalCredit([])
      set_AcGroupList([])
      set_All_AcGroupList([])
      set_AcClassList([])
      set_All_AcClassList([])
      set_AcCodeList([])
      set_All_AcCodeList([])
      if (res.type === 'success') {
        let data = JSON.parse(res.res.data)
        if (data.length === 0) {
          setMessgae(
            <Box sx={{ margin: 'auto' }}>
              <Alert severity='warning'>
                <AlertTitle>No Data Found</AlertTitle>
                There is no data to display at the moment.
              </Alert>
            </Box>
          )
          return
        }
        data = _.sortBy(data, 'itemdescription')

        set_fetchedData(data)
        set_displayData(data)

        let AcGrpArr = [
          ...new Set(
            data.map(each => {
              if (each.AcGrp) return each.AcGrp
            })
          )
        ].filter(each => each)

        let AcClassArr = [
          ...new Set(
            data.map(each => {
              if (each.AcClass) return each.AcClass
            })
          )
        ].filter(each => each)

        let AcCodeArr = [
          ...new Set(
            data.map(each => {
              if (each.AcCode) return each.AcCode
            })
          )
        ].filter(each => each)

        set_AcGroupList(AcGrpArr)
        set_All_AcGroupList(AcGrpArr)

        set_AcClassList(AcClassArr)
        set_All_AcClassList(AcClassArr)

        set_AcCodeList(AcCodeArr)
        set_All_AcCodeList(AcCodeArr)

        if (data.length) {
          let PatternGroup = [
            ...new Set(data.map(each => each['PatternGroup']))
          ]

          ALLOW_FOR_PATTERN.includes(LedgerType) &&
            PatternGroup.forEach(each => {
              each &&
                getRequest(
                  `api/veranda/getPatternGrp?LedgerType=${LedgerType}&PatternGroup=${each}&OrgID=${Company}`
                ).then(res => {
                  if (res.res.status === 'success') {
                    let File = res.res.data

                    let PATTERJSONS = PATTERN__JSONS

                    PATTERJSONS[each] = File

                    set_PATTERN__JSONS(PATTERJSONS)
                  }
                })
            })
        }

        set_totalDebit(
          data.reduce((total, item) => total + parseFloat(item['Debit']), 0)
        )
        set_totalCredit(
          data.reduce((total, item) => total + parseFloat(item['Credit']), 0)
        )
      }
    })
  }

  const onAcGroupFilter = newValue => {
    set_SelAcGroupList(newValue)
    set_SelAcClassList([])
    set_SelAcCodeList([])
    set_KeyRefList([])

    let newSet

    if (newValue.length) {
      newSet = fetchedData.filter(each => newValue.includes(each.AcGrp))
    } else {
      newSet = fetchedData
    }

    let AcClassArr = [
      ...new Set(
        newSet.map(each => {
          if (each.AcClass) return each.AcClass
        })
      )
    ].filter(each => each)

    set_AcClassList(AcClassArr)

    let AcCodeArr = [
      ...new Set(
        newSet.map(each => {
          if (each.AcCode) return each.AcCode
        })
      )
    ].filter(each => each)

    set_AcCodeList(AcCodeArr)

    set_displayData(newSet)

    if (newSet.length) {
      setSelectedRow(0)
    }
    set_totalDebit(
      newSet.reduce((total, item) => total + parseFloat(item['Debit']), 0)
    )
    set_totalCredit(
      newSet.reduce((total, item) => total + parseFloat(item['Credit']), 0)
    )
  }

  const onAcClassFilter = newValue => {
    set_SelAcClassList(newValue)
    set_SelAcCodeList([])
    set_KeyRefList([])

    let sel_AcGrp = SelAcGroupList.length ? SelAcGroupList : All_AcGroupList
    let sel_AcCls = newValue.length ? newValue : All_AcClassList

    let newSet = fetchedData.filter(
      each => sel_AcGrp.includes(each.AcGrp) && sel_AcCls.includes(each.AcClass)
    )

    let AcCodeArr = [
      ...new Set(
        newSet.map(each => {
          if (each.AcCode) return each.AcCode
        })
      )
    ].filter(each => each)

    set_AcCodeList(AcCodeArr)

    set_displayData(newSet)
    if (newSet.length) {
      setSelectedRow(0)
    }
    set_totalDebit(
      newSet.reduce((total, item) => total + parseFloat(item['Debit']), 0)
    )
    set_totalCredit(
      newSet.reduce((total, item) => total + parseFloat(item['Credit']), 0)
    )
  }

  const onAcCodeFilter = newValue => {
    set_SelAcCodeList(newValue)
    set_KeyRefList([])

    let sel_AcGrp = SelAcGroupList.length ? SelAcGroupList : All_AcGroupList
    let sel_AcCls = SelAcClassList.length ? SelAcClassList : All_AcClassList
    let sel_AcCd = newValue.length ? newValue : All_AcCodeList

    let newSet = fetchedData.filter(
      each =>
        sel_AcGrp.includes(each.AcGrp) &&
        sel_AcCls.includes(each.AcClass) &&
        sel_AcCd.includes(each.AcCode)
    )

    set_displayData(newSet)
    if (newSet.length) {
      setSelectedRow(0)
    }
    set_totalDebit(
      newSet.reduce((total, item) => total + parseFloat(item['Debit']), 0)
    )
    set_totalCredit(
      newSet.reduce((total, item) => total + parseFloat(item['Credit']), 0)
    )
  }

  const onKeyRefFilter = newValue => {
    set_KeyRefList(newValue)

    let newSet

    if (newValue.length) {
      newSet = fetchedData.filter(
        each =>
          SelAcGroupList.includes(each.AcGrp) &&
          SelAcClassList.includes(each.AcClass) &&
          newValue.includes(each.KeyRef)
      )
    } else {
      newSet = fetchedData.filter(
        each =>
          SelAcGroupList.includes(each.AcGrp) &&
          SelAcClassList.includes(each.AcClass)
      )
    }

    set_displayData(newSet)
    if (newSet.length) {
      setSelectedRow(0)
    }
    set_totalDebit(
      newSet.reduce((total, item) => total + parseFloat(item['Debit']), 0)
    )
    set_totalCredit(
      newSet.reduce((total, item) => total + parseFloat(item['Credit']), 0)
    )
  }

  const handleRowClick = index => {
    setSelectedRow(index === selectedRow ? null : index)
  }

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.keyCode === 38 || e.keyCode === 40) {
        if (e.keyCode === 38 && selectedRow > 0) {
          e.preventDefault()
          setSelectedRow(prev => prev - 1)
        } else if (e.keyCode === 40 && selectedRow < fetchedData.length - 1) {
          e.preventDefault()
          setSelectedRow(prev => (prev === null ? 0 : prev + 1))
        }
        scrollSelectedRowIntoView()
      }
      if (e.key === 'Enter' && selectedRow !== null) {
        setPopupVisible(true)
        CreditorsAc = Object.assign(
          {},
          fetchedData.find(
            data =>
              data.JournalRef === fetchedData[selectedRow].JournalRef &&
              data.createdid === fetchedData[selectedRow].createdid &&
              data.accounttype === 'CreditorsAc'
          )
        )
        setCreditorsAc(CreditorsAc)

        if (ALLOW_FOR_PATTERN.includes(LedgerType)) {
          let patgrp = displayData[selectedRow]['PatternGroup']

          if (!patgrp) {
            patgrp = PATTERN_GROUP[LedgerType]
          }
          set_PATTERN_JSON(PATTERN__JSONS[patgrp])
        }
        setOpenDialogue(true)
      }
    }

    const scrollSelectedRowIntoView = () => {
      if (tableRef.current && selectedRow !== null) {
        const row_up = tableRef.current.querySelector(
          `TableRow:nth-child(${selectedRow - 1})`
        )
        const row_down = tableRef.current.querySelector(
          `TableRow:nth-child(${selectedRow + 2})`
        )

        const row = tableRef.current.querySelector(
          `TableRow:nth-child(${selectedRow + 1})`
        )

        if (row) {
          const tableRect = tableRef.current.getBoundingClientRect()

          if (row_up) {
            const rowRect_up = row_up.getBoundingClientRect()

            if (rowRect_up.top < tableRect.top) {
              tableRef.current.scrollTop += rowRect_up.top - tableRect.top
            }
          }

          if (row_down) {
            const rowRect_down = row_down.getBoundingClientRect()

            if (rowRect_down.bottom > tableRect.bottom) {
              tableRef.current.scrollTop +=
                rowRect_down.bottom - tableRect.bottom
            }
          }
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [selectedRow])

  const on_Save = (PATTERJSON, givenInfo) => {
    let patgrp = displayData[selectedRow]['PatternGroup']

    if (!patgrp) {
      patgrp = PATTERN_GROUP[LedgerType]
    }

    set_PATTERN_JSON(PATTERJSON)

    let FULL = PATTERN__JSONS

    FULL[patgrp] = PATTERJSON

    set_PATTERN__JSONS(FULL)

    let tosend = {
      ...displayData[selectedRow],
      ...givenInfo,
      PatternGroup: patgrp
    }

    postRequest(
      `api/veranda/saveUpdatedPattern?LedgerType=${LedgerType}&PatternGroup=${patgrp}&OrgID=${Company}`,
      PATTERJSON
    ).then(res => {
      postRequest(
        `api/veranda/LedgerViewUpdate?module=${localStorage.getItem(
          'module'
        )}&LedgerType=${LedgerType}&PatternGroup=${patgrp}&OrgID=${Company}`,
        tosend
      ).then(res => {
        setPopupVisible(false)

        set_fetchedData([])
        set_displayData([])
        set_AcGroupList([])
        set_AcClassList([])
        set_PATTERN__JSONS({})
        set_totalDebit('')
        set_totalCredit('')
      })
    })
  }

  const handleClose = () => {
    setOpenDialogue(false)
  }

  const handleBackdropClose = (event, reason) => {
    if (reason && reason !== 'backdropClick') {
      handleClose()
    }
  }

  const handleChange = (event, newValue) => {
    setPopupview(newValue)
  }

  return (
    <Box>
      {/* <Dialog
        open={openDialogue}
        onClose={handleBackdropClose}
        maxWidth='lg'
        fullWidth
      >
        <TabContext value={popupView}>
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              position: 'relative'
            }}
          >
            <TabList onChange={handleChange} aria-label='lab API tabs example'>
              {displayData[selectedRow] &&
              displayData[selectedRow].accounttype === 'CreditorsAc' ? (
                <Tab label='connection' value='connection' />
              ) : (
                ''
              )}
              {ALLOW_FOR_PATTERN.includes(LedgerType) ? (
                <Tab label='pattern' value='pattern' />
              ) : (
                ''
              )}
            </TabList>
            <IconButton
              aria-label='close'
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 0,
                color: theme => theme.palette.grey[500]
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers> */}
      {/* {popupVisible && ALLOW_FOR_PATTERN.includes(LedgerType) ? (
        <TabPanel value='pattern'>
        <Pattern_Popup
          CreditorsAc={CreditorsAc}
          PATTERN_JSON={PATTERN_JSON}
          ROW={displayData[selectedRow]}
          setPopupVisible={setPopupVisible}
          on_Save={on_Save}
          IM={ItemMaster}
          VM={VendorMaster}
          LedgerType={LedgerType}
          BankAcClass={BankRef}
          OrgID={Company}
        />
      ) : (
         </TabPanel>
        ''
      )} */}

      {/* {CreditorsAc.accounttype &&
            CreditorsAc.accounttype === 'CreditorsAc' ? (
              <TabPanel value='connection'>
                {/* <Connections
                  setBillsByOrgID={setBillsByOrgID}
                  CreditorsAc={CreditorsAc}
                  ROW={displayData[selectedRow]}
                  setOpenDialogue={setOpenDialogue}
                  LedgerType={LedgerType}
                  OrgID={Company}
                  Bills={BillsByOrgID}
                  fetchBills={fetchBills}
                /> 
              </TabPanel>
            ) : (
              ''
            )}
          </DialogContent>
        </TabContext>
      </Dialog> */}

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant='h6'>Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2}>
              <Autocomplete
                size='small'
                fullWidth
                options={Companies.map(each => ({
                  label: `${each.orgname}(${each.orgid})`,
                  value: each.orgid
                }))}
                value={Company}
                getOptionLabel={option => {
                  if (typeof option === 'string') return option
                  return option?.label || ''
                }}
                isOptionEqualToValue={(option, value) =>
                  option?.value === value.value
                }
                onChange={(event, newValue) => updateCompany(newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Company Name'
                    variant='outlined'
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Autocomplete
                size='small'
                fullWidth
                options={Ledger_Type}
                value={LedgerType}
                onChange={(event, newValue) => updateLedger(newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='LedgerType'
                    variant='outlined'
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdFrom'
                  value={From}
                  views={['day', 'month', 'year']}
                  onChange={newValue => updateFrom(newValue)}
                  renderInput={params => <TextField size='small' {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdTo'
                  value={To}
                  views={['day', 'month', 'year']}
                  onChange={newValue => updateTo(newValue)}
                  renderInput={params => <TextField size='small' {...params} />}
                />
              </LocalizationProvider>
            </Grid>

            {/* <Grid item xs={12} sm={6} md={2}>
              <Autocomplete
                size='small'
                fullWidth
                options={AllKeyRef}
                value={KeyRef}
                onChange={(event, newValue) => updateKeyRef(newValue)}
                renderInput={params => (
                  <TextField {...params} label='Key Ref' variant='outlined' />
                )}
              />
            </Grid> */}

            <Grid item xs={1}>
              <Button
                variant='contained'
                color='primary'
                ref={buttonRef}
                disabled={!LedgerType || !From || !To}
                onClick={onFetch}
              >
                Fetch
              </Button>
            </Grid>
          </Grid>
          {fetchedData.length > 0 && (
            <>
              <Typography variant='h6' mt={1}>
                Filter
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    size='small'
                    multiple
                    id={'AcGroup'}
                    options={AcGroupList}
                    getOptionLabel={option => option}
                    fullWidth
                    value={SelAcGroupList}
                    onChange={(event, newValue) => {
                      onAcGroupFilter(newValue)
                    }}
                    renderInput={params => (
                      <TextField {...params} label={'AcGroup'} />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    size='small'
                    multiple
                    id={'AcClass'}
                    options={AcClassList}
                    getOptionLabel={option => option}
                    fullWidth
                    value={SelAcClassList}
                    onChange={(event, newValue) => {
                      onAcClassFilter(newValue)
                    }}
                    renderInput={params => (
                      <TextField {...params} label={'AcClass'} />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Autocomplete
                    size='small'
                    multiple
                    id={'AcCode'}
                    options={AcCodeList}
                    getOptionLabel={option => option}
                    fullWidth
                    value={SelAcCodeList}
                    onChange={(event, newValue) => {
                      onAcCodeFilter(newValue)
                    }}
                    renderInput={params => (
                      <TextField {...params} label={'AcCode'} />
                    )}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </AccordionDetails>
      </Accordion>

      {(fetchedData.length > 0 && (
        <Box>
          <Box
            align='right'
            sx={{
              m: 2,
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'row',
              gap: 2
            }}
          >
            <>
              <Pagination
                count={Math.ceil(displayData.length / rowsPerPage)}
                page={page + 1}
                onChange={(event, newPage) => {
                  handleChangePage(event, newPage - 1)
                }}
                variant='outlined'
                shape='rounded'
                showFirstButton
                showLastButton
              />
              &nbsp;
              <CSVLink
                size='sm'
                filename={`Ledgers_${moment().format(
                  'YYYY-MM-DD_HH-mm-ss'
                )}.csv`}
                data={fetchedData}
              >
                <Button variant='contained' color='success'>
                  <GetAppIcon />
                </Button>
              </CSVLink>
            </>
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    Txn
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    JournalRef
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    createdid
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    Receiver ID
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    Receiver Name
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    ExtDocRef
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    TallyLedgerName
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    accounttype
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    AcCode
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    Item Description
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    Debit
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2, whiteSpace: 'nowrap' }}
                  >
                    Credit
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(displayData.length > 0 &&
                  (rowsPerPage > 0
                    ? displayData.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                    : displayData
                  ).map((item, rowIndex) => (
                    <TableRow
                      onClick={() => handleRowClick(rowIndex)}
                      style={
                        selectedRow === rowIndex
                          ? { backgroundColor: 'lightblue' }
                          : null
                      }
                      key={rowIndex}
                    >
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['TxnStatus'] === 'Approved' ? (
                          <span style={{ fontSize: '1rem', color: 'green' }}>
                            <AiFillCheckSquare />
                          </span>
                        ) : item['TxnStatus'] === 'Rejected' ? (
                          <span style={{ fontSize: '1rem', color: 'red' }}>
                            <AiFillCloseSquare />
                          </span>
                        ) : item['TxnStatus'] === 'Waiting For Approval' ? (
                          <span style={{ fontSize: '1rem', color: 'orange' }}>
                            <AiFillClockCircle />
                          </span>
                        ) : (
                          <span style={{ fontSize: '1rem', color: 'orange' }}>
                            <AiFillClockCircle />
                          </span>
                        )}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['Date']}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['JournalRef']}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['CreatedID']}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['ReceiverID']}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['ReceiverName']}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['ExtDocRef']}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['TallyLedgerName']}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['AccountType']}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {item['AcCode']}
                      </TableCell>
                      <TableCell sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}>
                        {
                          <>
                            {(!readMoreItem.includes(
                              (page - 1) * rowsPerPage + rowIndex
                            ) &&
                              item['ItemDescription']?.length > 20 &&
                              `${item['ItemDescription']?.slice(0, 20)}
                          ...`) ||
                              `${item['ItemDescription']}`}
                            {item['ItemDescription']?.length > 20 && (
                              <Button
                                variant='text'
                                onClick={() =>
                                  handleReadMore(
                                    (page - 1) * rowsPerPage + rowIndex
                                  )
                                }
                                sx={{ whiteSpace: 'nowrap' }}
                              >
                                {(!readMoreItem.includes(
                                  (page - 1) * rowsPerPage + rowIndex
                                ) &&
                                  'Read more') ||
                                  'Read less'}
                              </Button>
                            )}
                          </>
                        }
                      </TableCell>
                      <TableCell
                        sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}
                        style={{ textAlign: 'right' }}
                      >
                        {item['Debit']}
                      </TableCell>
                      <TableCell
                        sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}
                        style={{ textAlign: 'right' }}
                      >
                        {item['Credit']}
                      </TableCell>
                    </TableRow>
                  ))) || (
                  <TableRow>
                    <TableCell colSpan={Object.keys(fetchedData[0]).length}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '100%'
                        }}
                      >
                        <Alert severity='error' variant='outlined'>
                          No matching records found. Please adjust your search criteria.
                        </Alert>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}
                    style={{
                      border: 'none',
                      textAlign: 'right',
                      fontWeight: 'bold'
                    }}
                    colSpan={11}
                  >
                    Total:
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}
                    style={{ textAlign: 'right' }}
                  >
                    {totalDebit}
                  </TableCell>
                  <TableCell
                    sx={{ pt: 0, pb: 0, pl: 2, pr: 2 }}
                    style={{ textAlign: 'right' }}
                  >
                    {totalCredit}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )) ||
        message}

      {displayData.length > 0 && selectedRow !== null && (
        <Paper
          elevation={3}
          sx={{ p: 1, position: 'sticky', bottom: 0, zIndex: 1 }}
        >
          <Stack spacing={2} direction='row'>
            {/* First Row */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormLabel
                  component='legend'
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    mr: 2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  AcGrp
                </FormLabel>
                <Typography variant='body1' display='inline'>
                  {displayData[selectedRow]['AcGrp'] || ''}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel
                  component='legend'
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    mr: 2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  AcClass
                </FormLabel>
                <Typography variant='body1' display='inline'>
                  {displayData[selectedRow]['AcClass'] || ''}
                </Typography>
              </Grid>
            </Grid>

            {/* Second Row */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormLabel
                  component='legend'
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    mr: 2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  ForPrdFrom
                </FormLabel>
                <Typography variant='body1' display='inline'>
                  {displayData[selectedRow]['ForPrdFrom'] || ''}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel
                  component='legend'
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    mr: 2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  ForPrdTo
                </FormLabel>
                <Typography variant='body1' display='inline'>
                  {displayData[selectedRow]['ForPrdTo'] || ''}
                </Typography>
              </Grid>
            </Grid>

            {/* Third Row */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormLabel
                  component='legend'
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    mr: 2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  Sender
                </FormLabel>
                <Typography variant='body1' display='inline'>
                  {displayData[selectedRow]['Sender'] || ''}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel
                  component='legend'
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    mr: 2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  Receiver
                </FormLabel>
                <Typography variant='body1' display='inline'>
                  {displayData[selectedRow]['ReceiverID'] || ''}
                </Typography>
              </Grid>
            </Grid>

            {/* Fourth Row */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormLabel
                  component='legend'
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    mr: 2,
                    whiteSpace: 'nowrap'
                  }}
                >
                  CostAllocationMethod
                </FormLabel>
                <Typography variant='body1' display='inline'>
                  {displayData[selectedRow]['CostAllocationMethod'] || ''}
                </Typography>
              </Grid>
            </Grid>
          </Stack>
        </Paper>
      )}
    </Box>
  )
}
